module.exports = __webpack_public_path__ + "img/Eduzz-4-es.ec26760a.png";